var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("注销账号")])}
var staticRenderFns = []

export { render, staticRenderFns }